import { render, staticRenderFns } from "./deleteDeclaration.vue?vue&type=template&id=8e419ffc"
import script from "./deleteDeclaration.vue?vue&type=script&lang=js"
export * from "./deleteDeclaration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports